import { api } from '../../DefaultService';
import {
  IWebhookCreateProps,
  IWebhookPayloadCreateProps,
  IWebhookPayloadSimpleProps,
  IWebhookPayloadUpdateParams,
  IWebhookProps,
  IWebhookSimpleProps,
  IWebhookUpdateParams,
} from './types';

const ENDPOINT = '/v1/integrations/webhook';

export const createWebhookIntegrationAsync = async (
  data: IWebhookCreateProps,
) => {
  return await api
    .post(`${ENDPOINT}`, data)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const getWebhookIntegrationByIdAsync = async (
  id: number,
): Promise<IWebhookProps> => {
  return await api
    .get<IWebhookProps>(`${ENDPOINT}/${id}`)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const updateWebhookIntegrationAsync = async ({
  id,
  data,
}: IWebhookUpdateParams) => {
  return await api
    .put(`${ENDPOINT}/${id}`, data)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const getAllWebhookIntegrationByLicense = async (): Promise<
  IWebhookSimpleProps[]
> => {
  return await api
    .get<IWebhookSimpleProps[]>(`${ENDPOINT}/getAllByLicense`)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const deleteWebhookIntegrationAsync = async (id: number) => {
  return await api.delete(`${ENDPOINT}/${id}`).catch((error) => {
    throw new Error(
      error?.response?.data?.message || 'Erro interno do servidor!',
    );
  });
};

export const getAllWebhookPayloadsByLicenseAsync = async (): Promise<
  IWebhookPayloadSimpleProps[]
> => {
  return await api
    .get<IWebhookPayloadSimpleProps[]>(`${ENDPOINT}/payloads/getAllByLicense`)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const createWebhookPayloadAsync = async (
  payload: IWebhookPayloadCreateProps,
): Promise<IWebhookPayloadSimpleProps> => {
  return await api
    .post<IWebhookPayloadSimpleProps>(`${ENDPOINT}/payloads`, payload)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const getWebhookPayloadByIdAsync = async (
  id: number,
): Promise<IWebhookPayloadSimpleProps> => {
  return await api
    .get<IWebhookPayloadSimpleProps>(`${ENDPOINT}/payloads/${id}`)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const updateWebhookPayloadByIdAsync = async ({
  id,
  data,
}: IWebhookPayloadUpdateParams): Promise<void> => {
  return await api
    .put(`${ENDPOINT}/payloads/${id}`, data)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const deleteWebhookPayloadByIdAsync = async (
  id: number,
): Promise<void> => {
  await api.delete(`${ENDPOINT}/payloads/${id}`).catch((error) => {
    throw new Error(
      error?.response?.data?.message || 'Erro interno do servidor!',
    );
  });
};
